

import { Component, Prop, Vue } from 'vue-property-decorator';
import { form16StatusInfoType } from '@/types/Information/Form16';

import StepNumber from "@/components/utils/StepNumber.vue";

@Component({
    components:{
        StepNumber
    }
})
export default class Form16ProcessHeader extends Vue {  
    
    @Prop({required: true})
    stepsCompleted!: form16StatusInfoType;

}
